var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoltSplash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M77.114 69.035c.357.102.6.403.6.742v3.89h3.429c.32 0 .612.16.76.417.148.258.125.568-.058.806l-6 7.777c-.214.279-.602.4-.96.297-.357-.102-.6-.403-.6-.742v-3.89h-3.428c-.32 0-.612-.16-.76-.417-.148-.258-.125-.568.058-.806l6-7.777c.214-.278.602-.398.96-.296z",
    transform: "translate(-189 -461) translate(119 392)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoltSplash);
export default __webpack_public_path__ + "static/media/bolt-splash.f544c76ec11e80dbc67aa53944d7c3dd.svg";
export { ForwardRef as ReactComponent };